
import { createAction } from 'redux-actions'
import * as ActionTypes from 'constants/actionType'

const initDirectoryPageAction = createAction(ActionTypes.INIT_DIRECTORY_PAGE)
const updateScaleAction = createAction(ActionTypes.UPDATE_SCALE)
const updateDisplayNavbarMenuAction = createAction(ActionTypes.UPDATE_DISPLAY_NAVBAR_MENU)
const updateDisplayShareDialogAction = createAction(ActionTypes.UPDATE_DISPLAY_SHARE_DIALOG)
const updateDisplayCoverImageAction = createAction(ActionTypes.UPDATE_DISPLAY_COVER_IMAGE)
const updateDisplayIntroAction = createAction(ActionTypes.UPDATE_DISPLAY_INTRO)
const updateSelectedDateAction = createAction(ActionTypes.UPDATE_SELECTED_DATE)
const updateSelectedTimeAction = createAction(ActionTypes.UPDATE_SELECTED_TIME)
const updateSelectedShippingAction = createAction(ActionTypes.UPDATE_SELECTED_SHIPPING)
const updateDisplayBackdropLoadingAction = createAction(ActionTypes.UPDATE_DISPLAY_BACKDROP_LOADING)
const updateDisplayAction = createAction(ActionTypes.UPDATE_DISPLAY)

export const initDirectoryPage = (bool) => (dispatch, getState) => {
  dispatch(initDirectoryPageAction({ init: bool }))
}

export const updateScale = (scale) => (dispatch, getSTate) => {
  dispatch(updateScaleAction({ scale })) // string
}

export const updateDisplayNavbarMenu = (bool) => (dispatch, getState) => {
  dispatch(updateDisplayNavbarMenuAction({ display: bool }))
}

export const updateDisplayShareDialog = (bool) => (dispatch, getState) => {
  dispatch(updateDisplayShareDialogAction({ display: bool }))
}

export const updateDisplayCoverImage = (bool) => (dispatch, getState) => {
  dispatch(updateDisplayCoverImageAction({ display: bool }))
}

export const updateDisplayIntro = (bool) => (dispatch, getState) => {
  dispatch(updateDisplayIntroAction({ display: bool }))
}

export const updateSelectedDate = (date) => (dispatch, getState) => {
  dispatch(updateSelectedDateAction({ date })) // string
}

export const updateSelectedTime = (time) => (dispatch, getState) => {
  dispatch(updateSelectedTimeAction({ time })) // string
}

export const updateSelectedShipping = (shipping) => (dispatch, getState) => {
  dispatch(updateSelectedShippingAction({ shipping })) // object
}

export const updateDisplayBackdropLoading = (bool) => (dispatch, getState) => {
  dispatch(updateDisplayBackdropLoadingAction({ display: bool }))
}

export const updateDisplay = (target, display) => (dispatch, getState) => {
  dispatch(updateDisplayAction({ target, display }))
}



// WEBPACK FOOTER //
// ./src/actions/components/directory.js